import { render, staticRenderFns } from "./WidgetSearch.vue?vue&type=template&id=903a633a&"
import script from "./WidgetSearch.vue?vue&type=script&lang=js&"
export * from "./WidgetSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WidgetSearch.vue"
export default component.exports